import { useSelector } from 'react-redux'
import { selectIsSyncedCustomer } from 'reducers/UserInfo'

export const useIsSyncedCustomer = () => useSelector(selectIsSyncedCustomer);
